<template>
  <el-collapse v-model="activeNames" ref="collapseWrap" class="collapse-wrap">
    <el-collapse-item
      v-for="(group, index) in groups"
      :key="index"
      :title="group.name"
      :name="index"
      :class="{ 'hide-last2': !(group.controls.length % 2) }"
    >
      <field-item
        v-for="control in group.controls"
        :key="control._cid"
        :control="control"
        :class="'field-item-' + widthLevel"
        :value="getValue(control._cid)"
        :string-value="getValue(control._cid, 'string')"
        :style="widthLevel == '2' ? 'width:' + width + 'px' : ''"
      ></field-item>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import { systemControls } from "./static"
import FieldItem from "./FieldItem"
import { randomString } from "@/utils/common"

export default {
  name: "data-detail",
  components: {
    FieldItem
  },
  data() {
    return {
      systemControls,
      activeNames: [],
      clientWidth: 0
    }
  },
  props: {
    sheetDef: {
      type: Object,
      default: () => ({})
    },
    sheetData: {
      type: Object,
      default: () => ({})
    },
    widthLevel: {
      type: String,
      default: "1"
    }
  },
  computed: {
    cidControlMap() {
      let controls = this.sheetDef.controls || []
      return this._.keyBy(controls, "_cid")
    },
    groups() {
      let groups = []
      if (!this.sheetDef?.layout?.groupList) return []
      for (let group of this.sheetDef.layout.groupList) {
        if (group.cidList.length == 0) continue
        let controls = []
        for (let cid of group.cidList) {
          let field = this.cidControlMap[cid]
          if (!field || !field.display) continue
          if (!["ref", "chart"].includes(field._type) || (field._type == "ref" && field.oneFlag))
            controls.push(field)
        }
        if (controls.length > 0) groups.push({ name: group.name, controls })
      }
      let showSystemFields = systemControls.filter(
        systemField => !this.sheetDef.layout.hiddenCids.includes(systemField.cid)
      )
      if (showSystemFields.length) {
        let systemInfo = {
          name: "系统信息",
          tempId: randomString(10),
          controls: showSystemFields
        }
        groups.push(systemInfo)
      }
      if (this.sheetDef.projectRelated) {
        // 把项目信息强行塞到第一个分组的第一个字段里
        groups[0]?.controls?.unshift({
          _cid: "project",
          _dataType: "string",
          _type: "text",
          display: true,
          name: "项目"
        })
      }
      return groups
    },
    dataMap() {
      if (!this.sheetData.data) return {}
      let data = {}
      for (let cid in this.sheetData.data) {
        switch (this.cidControlMap[cid]?._type) {
          case "option":
            data[cid] = this.sheetData.dataForShow[cid + "_o"]
            break
          case "file":
          case "ref":
          case "rich":
          case "staff":
            data[cid] = this.sheetData.data[cid]
            break
          default:
            data[cid] = this.sheetData.dataForShow[cid]
        }
      }
      return {
        ...data,
        createAt: this.sheetData.createAt,
        creator: this.sheetData.creator?.name,
        updateUser: this.sheetData.updateUser?.name,
        updateAt: this.sheetData.updateAt,
        owner: this.sheetData.owner?.name,
        project: this.sheetData.projectName
      }
    },
    width() {
      let width = 32
      if (this.clientWidth / 276 > 4) width = (this.clientWidth - 20 * 4) / 4
      else if (this.clientWidth / 276 > 3) width = (this.clientWidth - 20 * 3) / 3
      else width = (this.clientWidth - 20 * 2) / 2
      return width
    }
  },
  mounted() {
    let elementResizeDetectorMaker = require("element-resize-detector")
    let erd = elementResizeDetectorMaker()
    erd.listenTo(this.$refs.collapseWrap.$el, () => {
      this.clientWidth = this.$refs.collapseWrap.$el.clientWidth
    })
  },
  methods: {
    init() {
      this.activeNames = this._.range(0, this.groups.length)
    },
    getValue(cid, type) {
      let commonMap = {
        createAt: this.sheetData.createAt,
        creator: this.sheetData.creator,
        updateUser: this.sheetData.updateUser,
        updateAt: this.sheetData.updateAt,
        owner: this.sheetData.owner,
        project: this.sheetData.projectName
      }
      if (commonMap[cid] !== undefined) {
        return type == "string" && this._.isObject(commonMap[cid])
          ? commonMap[cid].name
          : commonMap[cid]
      }
      return type === "string" ? this.sheetData.dataForShow[cid] : this.sheetData.data[cid]
    }
  }
}
</script>

<style lang="scss" scoped>
.collapse-wrap {
  margin: 0 0 70px 0;
  border-top: none;
  border-bottom: none;
  ::v-deep {
    .el-collapse-item {
      position: relative;
      &::before {
        content: "";
        position: absolute;
        top: 6px;
        width: 4px;
        height: 18px;
        border-radius: 4px;
        background-color: #1989fa;
      }
      &::after {
        content: "";
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        height: 0;
        width: 100%;
        border-bottom: 1px solid #e4e4e4;
      }
      &.is-active {
        &::after {
          border-bottom: unset;
        }
      }
      // border-bottom: 1px solid #e4e4e4;
      // &.hide-last2 .field-item:nth-last-child(2) {
      //   border-bottom: none;
      // }
    }
    .el-collapse-item + .el-collapse-item {
      margin-top: 10px;
    }
    .el-collapse-item.is-active + .el-collapse-item {
      margin-top: 20px;
    }
    .el-collapse-item__header,
    .el-collapse-item__wrap {
      border-bottom: none;
    }
    .el-collapse-item__header,
    .el-collapse-item__content {
      color: $color-font-title;
    }
    .el-collapse-item__header {
      margin-left: 10px;
      height: 30px;
      line-height: 30px;
      font-size: $font-size-main;
      font-weight: bold;
      .el-collapse-item__arrow {
        margin-left: 10px;
        color: $color-font-second;
      }
    }
    .el-collapse-item__content {
      display: flex;
      flex-wrap: wrap;
      padding-bottom: 0;
      .field-item-1 {
        width: calc(50% - 20px);
        margin-right: 20px;
        box-sizing: border-box;
        border-bottom: 1px solid #e4e4e4;
      }
      .field-item-2 {
        border-bottom: 1px solid #e4e4e4;
        box-sizing: border-box;
        margin-right: 20px;
        .label {
          width: 96px;
          min-width: 96px;
          margin-right: 6px;
        }
      }
    }
  }
}
</style>
